define.alias("ember-tooltips/components/ember-popover", "media/components/ember-popover");